"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEMBERS_APP_DEF_ID = '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9';
exports.MEMBERS_INFO_APP_ID = '14cffd81-5215-0a7f-22f8-074b0e2401fb';
exports.EVENTS_APP_ID = '140603ad-af8d-84a5-2c80-a0f60cb47351';
exports.MEMBERS_INFO_SECTION_ID = 'member_info';
exports.MEMBERS_PAGE_SECTION_ID = 'events_members_page';
